import axios from 'axios';
import * as serverconfig from './serverconn';

var CryptoJS = require('crypto-js');

export function getSaccoIdForImport() {
  if (localStorage.getItem('sacco')) {
    return CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
  }
  return '';
}

export function fetchImportJobStatus(jobId) {
  const sacco = getSaccoIdForImport();
  return axios.get(
    `${serverconfig.backendserverurl}/customqueries/import_jobs/${jobId}?sacco=${sacco}`
  );
}

export function downloadImportJobReport(jobId) {
  const sacco = getSaccoIdForImport();
  window.open(
    `${serverconfig.backendserverurl}/customqueries/import_jobs/${jobId}/download?sacco=${sacco}`,
    '_blank'
  );
}

export function pollImportJobUntilDone(jobId, { onUpdate, intervalMs = 3000, maxAttempts = 400 } = {}) {
  let attempts = 0;
  return new Promise((resolve, reject) => {
    const tick = () => {
      attempts += 1;
      fetchImportJobStatus(jobId)
        .then((res) => {
          const job = res.data.job;
          if (onUpdate) {
            onUpdate(job);
          }
          if (job.status === 'done' || job.status === 'failed') {
            resolve(job);
            return;
          }
          if (attempts >= maxAttempts) {
            reject(new Error('Import status polling timed out.'));
            return;
          }
          setTimeout(tick, intervalMs);
        })
        .catch(reject);
    };
    tick();
  });
}

export function importStatusTagColor(status) {
  if (status === 'done') return 'success';
  if (status === 'failed') return 'error';
  if (status === 'running') return 'processing';
  return 'default';
}

export function formatImportJobSummary(job) {
  if (!job) return '';
  return `${job.imported_count || 0} imported, ${job.skipped_count || 0} skipped, ${job.failed_count || 0} failed`;
}
